import { createAction } from 'typesafe-actions';

import { CapabilitiesActions } from '../constants/Capabilities';

interface SetCapabilitiesParams {
  isMobile: boolean;
  isTablet: boolean;
}

export const setCapabilities = createAction(
  CapabilitiesActions.SET_CAPABILITIES,
  ({ isMobile = false, isTablet = false }: SetCapabilitiesParams) => ({ isMobile, isTablet }),
)<SetCapabilitiesParams>();
export type SetCapabilitiesAction = ReturnType<typeof setCapabilities>;
